import { Paragraph, tokens, Tooltip } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import {
	Container,
	Header,
	HeaderRow,
	TableHead,
	TableCell,
	TableWrapper,
	Disclaimer,
} from './ExamsPreview.styles';
import { Status } from 'App/Components/Status/Status';
import { ReactComponent as Heart } from 'App/assets/img/heart.svg';
import { ReactComponent as HeartGreen } from 'App/assets/img/heartGreen.svg';

type ExamProps = {
	name: string;
	sla: number;
	healthCenterName: string;
	orderStatus: 'pendingResult' | 'result';
};

type ExamsPreviewProps = {
	exams: ExamProps[];
	name: string;
	onClose: () => void;
};

const pendingTypes = ['pendingResult', 'pendent'];

export const ExamsPreview = ({ name, exams, onClose }: ExamsPreviewProps) => {
	const getTooltipText = (status: string) => {
		return pendingTypes.includes(status)
			? 'Resultados pendiente'
			: 'Resultados recibidos';
	};

	return (
		<Container>
			<Header>
				<Paragraph
					fontSize="16px"
					fontWeight="600"
					textAlign="center"
					color={tokens.color_primary}
				>
					Estudios médicos
				</Paragraph>
				<Paragraph fontWeight="600" textAlign="center">
					Los estudios médicos del candidato {name}
				</Paragraph>
			</Header>

			<TableWrapper>
				<table>
					<HeaderRow>
						<TableHead $width="185px">Estudio</TableHead>
						<TableHead $width="185px">Entrega de resultados</TableHead>
						<TableHead $width="135px">Laboratorio</TableHead>
						<TableHead $width="111px">Resultado</TableHead>
						<TableHead $width="126px">Status</TableHead>
					</HeaderRow>

					<tbody>
						{exams.map((exam: any) => (
							<tr key={exam.name}>
								<TableCell>
									<Paragraph
										elipsis
										width="165px"
										fontWeight="500"
										title={exam.name}
									>
										{exam.name}
									</Paragraph>
								</TableCell>
								<TableCell>{exam.sla} días hábiles</TableCell>
								<TableCell>{exam?.healthCenterName || '-'}</TableCell>
								<TableCell>
									<Tooltip title={getTooltipText(exam.orderStatus)}>
										{pendingTypes.includes(exam.orderStatus) ? (
											<Heart className="heart-icon pending" />
										) : (
											<HeartGreen className="heart-icon" />
										)}
									</Tooltip>
								</TableCell>
								<TableCell>
									<Status status={exam.orderStatus} />
								</TableCell>
							</tr>
						))}
					</tbody>
				</table>
			</TableWrapper>

			<Disclaimer>
				<Paragraph
					fontStyle="italic"
					fontWeight="500"
					textAlign="center"
					width="560px"
				>
					El tiempo de recepción de resultados se estima a partir de que el
					candidato acude al laboratorio y es distinto para cada estudio.
				</Paragraph>
				<Button variant="outline" width="182px" onClick={onClose}>
					Cerrar
				</Button>
			</Disclaimer>
		</Container>
	);
};
